export const between = (x: number, min: number, max: number) => {
  return x >= min && x <= max;
};

export const generateRandomId = () => {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let id = "";

  for (let i = 0; i < 20; i++) {
    if (i > 0 && i % 5 === 0) {
      id += "-"; // Add a dash every 5 characters
    }
    id += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return id;
};

export const amountWithCommas = (x: string) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const randomNumber = (min: number, max: number) => {
  let number = Math.random() * (max - min) + min;
  return Math.floor(number);
};

export const returnkW = (gpu_name: string) => {
  if (gpu_name == undefined) return;
  if (gpu_name.includes("H100")) {
    return "120";
  } else if (gpu_name.includes("4090")) {
    return "55";
  } else {
    return randomNumber(22, 80);
  }
};
